import { IconButton } from 'src/components/Buttons/IconButton';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { OpenLinkIcon } from 'src/svgs/OpenLinkIcon';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './RetailTableComponents.css';

export function SalePill({
  label,
  isGroup = false,
  onOpen,
}: {
  label: string;
  isGroup?: boolean;
  onOpen: () => void;
}) {
  return (
    <Stack gap={'s'} className={styles.pillContainer} onClick={onOpen}>
      {isGroup ? `\u25A0 ${label}` : label}
      <IconButton
        icon={
          <OpenLinkIcon
            size={vars.iconSize.s}
            withHoverEffect
            fill={vars.color.textBrandV2}
          />
        }
        titleContentId={ContentId.ViewDetails}
      />
    </Stack>
  );
}
